"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = exports.TableBody = exports.TableRow = exports.TableHead = exports.TableCell = exports.TableCheckboxAll = exports.TableCheckbox = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Table_1 = __importDefault(require("@material-ui/core/Table"));
const TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));
const TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
const TableContainer_1 = __importDefault(require("@material-ui/core/TableContainer"));
const TableHead_1 = __importDefault(require("@material-ui/core/TableHead"));
const TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
const app_1 = require("@obvio/app");
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
const context_1 = require("./context");
const Button_1 = require("../Button");
const utils_2 = require("../Form/Inputs/utils");
const Loading_1 = require("../Loading");
__exportStar(require("./context"), exports);
const StyledTable = (0, app_1.styled)(Table_1.default) `
  background: white;
  border-radius: ${(theme) => theme.radius.small};
`;
const StyledTableCell = (0, app_1.styled)(TableCell_1.default) `
  min-width: ${(_, { $width }) => $width};
  cursor: ${(_, { $sort }) => ($sort ? 'pointer' : 'default')};
  &.MuiTableCell-head {
    color: ${(theme) => theme.colors.gray.semidark};
    font-family: ${(theme) => theme.font};
    font-weight: unset;
    font-size: 0.8125rem;
    background: white;
  }
  &.MuiTableCell-body {
    color: ${(theme) => theme.colors.primary.deep};
    font-family: ${(theme) => theme.font};
    font-size: 0.8125rem;
    border-bottom: ${(theme) => `0.0625rem solid ${theme.stroke}`};
  }
`;
const TableCellNoBorder = (0, app_1.styled)(TableCell_1.default) `
  &.MuiTableCell-head {
    color: ${(theme) => theme.colors.gray.semidark};
    font-family: ${(theme) => theme.font};
    font-weight: unset;
    font-size: 0.8125rem;
    background: white;
  }
  &.MuiTableCell-body {
    color: ${(theme) => theme.colors.primary.deep};
    font-family: ${(theme) => theme.font};
    font-size: 0.8125rem;
    border-bottom: none;
  }
`;
const StyledArrow = app_1.styled.span `
  margin-left: ${(theme) => theme.spacing.small};
`;
const StyledTableContainer = (0, app_1.styled)(TableContainer_1.default) `
  border-radius: ${(theme) => theme.radius.small};
`;
function TableCheckbox({ id }) {
    const { select, selected } = (0, react_1.useContext)(context_1.TableContext);
    const handleChange = (0, react_1.useCallback)((ev) => select(id, ev.currentTarget.checked), [id, select]);
    return (0, jsx_runtime_1.jsx)(utils_2.Checkbox, { checked: selected.has(id), onChange: handleChange });
}
exports.TableCheckbox = TableCheckbox;
function TableCheckboxAll() {
    const { selectAll } = (0, react_1.useContext)(context_1.TableContext);
    return (0, jsx_runtime_1.jsx)(utils_2.Checkbox, { onChange: (ev) => selectAll(ev.currentTarget.checked) });
}
exports.TableCheckboxAll = TableCheckboxAll;
function TableCell(_a) {
    var { keyName, sort = false, children, width } = _a, props = __rest(_a, ["keyName", "sort", "children", "width"]);
    const tableContext = (0, react_1.useContext)(context_1.TableContext);
    const { changeSorter, sorters } = tableContext;
    const sorter = keyName ? sorters[keyName] : undefined;
    return ((0, jsx_runtime_1.jsxs)(StyledTableCell, Object.assign({}, props, { width: width, "$width": width, "$sort": sort }, (sort ? { sortDirection: sorter } : {}), { onClick: () => changeSorter && sort && keyName && changeSorter(keyName) }, { children: [children, sorter && (0, jsx_runtime_1.jsx)(StyledArrow, { children: sorter === 'desc' ? '↑' : '↓' })] })));
}
exports.TableCell = TableCell;
const StyledTableHead = (0, app_1.styled)(TableHead_1.default) `
  border-bottom: ${(theme) => `0.0625rem solid ${theme.stroke}`};
`;
function TableHead(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const context = (0, react_1.useContext)(context_1.TableContext);
    const { colSpanRef } = context || {};
    if (!Array.isArray(children)) {
        colSpanRef.current = react_1.Children.toArray(children.props.children).reduce((acc, child) => {
            if ((0, react_1.isValidElement)(child)) {
                return acc + (react_1.Children.count(child.props.children) || 1);
            }
            return acc + 1;
        }, 0);
    }
    return (0, jsx_runtime_1.jsx)(StyledTableHead, Object.assign({}, props, { children: children }));
}
exports.TableHead = TableHead;
const StyledTableRow = (0, app_1.styled)(TableRow_1.default) `
  cursor: pointer;
  height: 3.4375rem;
  background-color: ${(theme, { $selected }) => $selected && theme.colors.primary.alpha(0.1)};
  > td {
    color: ${(theme, { $selected }) => $selected && theme.colors.primary.semidark} !important;
  }
  &:last-child > .MuiTableCell-body {
    border-bottom: 0px;
  }
  transition: background-color 150ms;
  & > * {
    border-bottom: unset;
  }
`;
function TableRow(_a) {
    var { id, children } = _a, props = __rest(_a, ["id", "children"]);
    const context = (0, react_1.useContext)(context_1.TableContext);
    const theme = (0, app_1.useTheme)();
    const { innerPadding } = context || {};
    const selected = context.selected.has(id);
    if (innerPadding) {
        return ((0, jsx_runtime_1.jsxs)(StyledTableRow, Object.assign({}, props, { "$selected": selected }, { children: [(0, jsx_runtime_1.jsx)(TableCellNoBorder, { width: theme.spacing.small }), children, (0, jsx_runtime_1.jsx)(TableCellNoBorder, { width: theme.spacing.small })] })));
    }
    return ((0, jsx_runtime_1.jsx)(StyledTableRow, Object.assign({}, props, { "$selected": selected }, { children: children })));
}
exports.TableRow = TableRow;
function TableBody({ children, fetchMore, }) {
    const { data, loading, colSpanRef } = (0, context_1.useTableContext)();
    return ((0, jsx_runtime_1.jsx)(TableBody_1.default, { children: loading ? ((0, jsx_runtime_1.jsx)(TableRow, { children: (0, jsx_runtime_1.jsx)(TableCell, Object.assign({ colSpan: colSpanRef.current }, { children: (0, jsx_runtime_1.jsx)(Loading_1.Loading, {}) })) })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [children, Array.isArray(data) && (data === null || data === void 0 ? void 0 : data.length) && fetchMore ? ((0, jsx_runtime_1.jsx)(TableRow, { children: (0, jsx_runtime_1.jsx)(TableCell, Object.assign({ colSpan: colSpanRef.current }, { children: (0, jsx_runtime_1.jsx)(Button_1.Button, Object.assign({ kind: "transparent", onClick: () => fetchMore() }, { children: "Load more" })) })) })) : null] })) }));
}
exports.TableBody = TableBody;
function Table(_a) {
    var { children, innerPadding = false, className, onSort, removeHandler, onClickOutside, loading: initialLoading = false } = _a, props = __rest(_a, ["children", "innerPadding", "className", "onSort", "removeHandler", "onClickOutside", "loading"]);
    const tableRef = (0, react_1.useRef)(null);
    const [loading, setLoading] = (0, react_1.useState)(initialLoading);
    const [data, setData] = (0, react_1.useState)();
    const [selected, setSelected] = (0, react_1.useState)(new Set());
    const [sorters, setSorters] = (0, react_1.useState)({});
    const colSpanRef = (0, react_1.useRef)(0);
    const changeSorter = (0, react_1.useCallback)((dimension) => {
        const currentVal = sorters[dimension];
        if (currentVal === 'desc') {
            const _a = sorters, _b = dimension, _ = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            setSorters(rest);
        }
        else {
            setSorters({ [dimension]: currentVal ? 'desc' : 'asc' });
        }
    }, [sorters]);
    (0, app_1.useOnClickOutside)(tableRef, onClickOutside);
    const select = (0, react_1.useCallback)((id, bool) => setSelected((currentSelected) => {
        if (!bool) {
            currentSelected.delete(id);
            return new Set(currentSelected);
        }
        currentSelected.add(id);
        return new Set(currentSelected);
    }), []);
    const selectAll = (0, react_1.useCallback)((bool) => setSelected(bool
        ? new Set(data
            ? data === null || data === void 0 ? void 0 : data.map((record) => record.id)
            : [])
        : new Set()), [data]);
    const setInnerData = (0, react_1.useCallback)((cbData) => {
        setData(cbData);
        setLoading(false);
    }, []);
    const removeItem = (0, react_1.useCallback)((id) => __awaiter(this, void 0, void 0, function* () {
        yield (removeHandler === null || removeHandler === void 0 ? void 0 : removeHandler(id));
        setData((currentData) => {
            var _a;
            return ((_a = currentData === null || currentData === void 0 ? void 0 : currentData.filter((v) => v.id !== id)) !== null && _a !== void 0 ? _a : []);
        });
        selectAll(false);
    }), [removeHandler, selectAll]);
    const removeSelectedItems = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        yield (removeHandler === null || removeHandler === void 0 ? void 0 : removeHandler(...selected));
        setData((currentData) => currentData === null || currentData === void 0 ? void 0 : currentData.filter(({ id }) => !selected.has(id)));
        selectAll(false);
    }), [removeHandler, selected, selectAll]);
    const contextValue = (0, react_1.useMemo)(() => ({
        selected,
        sorters,
        innerPadding,
        loading,
        colSpanRef,
        data,
        select,
        selectAll,
        changeSorter,
        setLoading,
        setData: setInnerData,
        removeItem,
        removeSelectedItems,
    }), [
        selected,
        sorters,
        innerPadding,
        loading,
        data,
        selectAll,
        changeSorter,
        setInnerData,
        removeItem,
        select,
        removeSelectedItems,
    ]);
    return ((0, jsx_runtime_1.jsx)(app_1.Context, Object.assign({ name: "table" }, { children: (0, jsx_runtime_1.jsx)(context_1.TableContext.Provider, Object.assign({ value: contextValue }, { children: (0, jsx_runtime_1.jsx)(StyledTableContainer, Object.assign({ ref: tableRef }, (0, utils_1.exclude)({ className }, undefined), { children: (0, jsx_runtime_1.jsx)(StyledTable, Object.assign({ "aria-label": "collapsible table" }, (0, utils_1.exclude)(Object.assign({}, props), undefined), { children: children })) })) })) })));
}
exports.Table = Table;
